import { Navigate, useLocation, useParams } from "react-router-dom";

const LegacyContractRedirect = () => {
  const { token, id } = useParams<{ token?: string; id?: string }>();
  const { search, hash } = useLocation();
  const contractToken = token ?? id;

  if (!contractToken) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/contract/${contractToken}${search}${hash}`} replace />;
};

export default LegacyContractRedirect;
